import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wordToCamel'
})
export class WordToCamelPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return null;
  }
}
